// Recovered compiled webpack factory 12709. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { b: () => g });
  var n = i(33182),
    s = i(88786),
    r = i(20091),
    o = i(78041),
    a = i(23863),
    l = i(21391);
  let h = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
  var u = i(63946),
    d = i(15075),
    c = i(24888),
    p = i(82264);
  let m = new Set(["auto", "none", "0"]);
  var f = i(78617);
  class v extends u.h {
    constructor(t, e, i, n, s) {
      super(t, e, i, n, s, !0);
    }
    readKeyframes() {
      let { unresolvedKeyframes: t, element: e, name: i } = this;
      if (!e || !e.current) return;
      super.readKeyframes();
      for (let i = 0; i < t.length; i++) {
        let n = t[i];
        if ("string" == typeof n && ((n = n.trim()), (0, l.pG)(n))) {
          let s = (function t(e, i, n = 1) {
            (0, o.V)(
              n <= 4,
              `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`,
              "max-css-var-depth",
            );
            let [s, r] = (function (t) {
              let e = h.exec(t);
              if (!e) return [,];
              let [, i, n, s] = e;
              return [`--${i ?? n}`, s];
            })(e);
            if (!s) return;
            let u = window.getComputedStyle(i).getPropertyValue(s);
            if (u) {
              let t = u.trim();
              return (0, a.i)(t) ? parseFloat(t) : t;
            }
            return (0, l.pG)(r) ? t(r, i, n + 1) : r;
          })(n, e.current);
          (void 0 !== s && (t[i] = s), i === t.length - 1 && (this.finalKeyframe = n));
        }
      }
      if ((this.resolveNoneKeyframes(), !s.$.has(i) || 2 !== t.length)) return;
      let [n, u] = t,
        d = (0, r.n)(n),
        c = (0, r.n)(u);
      if ((0, l.rm)(n) !== (0, l.rm)(u) && f.Hr[i]) {
        this.needsMeasurement = !0;
        return;
      }
      if (d !== c)
        if ((0, f.E4)(d) && (0, f.E4)(c))
          for (let e = 0; e < t.length; e++) {
            let i = t[e];
            "string" == typeof i && (t[e] = parseFloat(i));
          }
        else f.Hr[i] && (this.needsMeasurement = !0);
    }
    resolveNoneKeyframes() {
      let { unresolvedKeyframes: t, name: e } = this,
        i = [];
      for (let e = 0; e < t.length; e++) {
        var n;
        (null === t[e] ||
          ("number" == typeof (n = t[e])
            ? 0 === n
            : null === n || "none" === n || "0" === n || (0, d.$)(n))) &&
          i.push(e);
      }
      i.length &&
        (function (t, e, i) {
          let n,
            s = 0;
          for (; s < t.length && !n; ) {
            let e = t[s];
            ("string" == typeof e && !m.has(e) && (0, c.V)(e).values.length && (n = t[s]), s++);
          }
          if (n && i) for (let s of e) t[s] = (0, p.J)(i, n);
        })(t, i, e);
    }
    measureInitialState() {
      let { element: t, unresolvedKeyframes: e, name: i } = this;
      if (!t || !t.current) return;
      ("height" === i && (this.suspendedScrollY = window.pageYOffset),
        (this.measuredOrigin = f.Hr[i](t.measureViewportBox(), window.getComputedStyle(t.current))),
        (e[0] = this.measuredOrigin));
      let n = e[e.length - 1];
      void 0 !== n && t.getValue(i, n).jump(n, !1);
    }
    measureEndState() {
      let { element: t, name: e, unresolvedKeyframes: i } = this;
      if (!t || !t.current) return;
      let n = t.getValue(e);
      n && n.jump(this.measuredOrigin, !1);
      let s = i.length - 1,
        r = i[s];
      ((i[s] = f.Hr[e](t.measureViewportBox(), window.getComputedStyle(t.current))),
        null !== r && void 0 === this.finalKeyframe && (this.finalKeyframe = r),
        this.removedTransforms?.length &&
          this.removedTransforms.forEach(([e, i]) => {
            t.getValue(e).set(i);
          }),
        this.resolveNoneKeyframes());
    }
  }
  var y = i(12583);
  class g extends y.BX {
    constructor() {
      (super(...arguments), (this.KeyframeResolver = v));
    }
    sortInstanceNodePosition(t, e) {
      return 2 & t.compareDocumentPosition(e) ? 1 : -1;
    }
    getBaseTargetFromProps(t, e) {
      let i = t.style;
      return i ? i[e] : void 0;
    }
    removeValueFromRenderState(t, { vars: e, style: i }) {
      (delete e[t], delete i[t]);
    }
    handleChildMotionValue() {
      this.childSubscription && (this.childSubscription(), delete this.childSubscription);
      let { children: t } = this.props;
      (0, n.S)(t) &&
        (this.childSubscription = t.on("change", (t) => {
          this.current && (this.current.textContent = `${t}`);
        }));
    }
  }
}
